import { isNullOrUndefined } from './IsNullOrUndefined';
/**
 * @return value for fallback provided
 */
export function valueOrFallback(value, fallback) {
    if (isNullOrUndefined(value)) {
        return fallback;
    }
    return value;
}
//# sourceMappingURL=ValueOrFallback.js.map